module.exports = __webpack_public_path__ + "img/01-MyTip-01.117d8efc.png";